// Hook de analytics preparado para a landing page.
// Não envia nada até que uma ferramenta (GA4, Plausible, etc.) seja configurada
// via variável de ambiente VITE_ANALYTICS_ID — só então plugue a chamada real aqui.
const analyticsId = import.meta.env.VITE_ANALYTICS_ID

export function trackEvent(eventName, props = {}) {
  if (!analyticsId) return

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, props)
  }
}
